// dta-badges.js - the Dragons Trainers Academy badges a coach can wear in the
// Coach Hub.
//
// Six finished roundels, one per level, drawn by the club. Each already carries
// its own name around the rim AND its own metal, so nothing here adds rings,
// stars or numbers on top: the artwork ranks itself twice over and a third
// system would only argue with it.
//
// The LABEL IS NOT TRANSLATED, deliberately. What is printed on the badge is
// what it is called, and "Assistent Trainer" under a roundel that reads ASSISTENT
// TRAINER is right in both languages. Translating the label would put a Dutch
// word under an English badge, or the reverse, and make the two disagree. Only
// the surrounding UI (the heading, the hint, "no badge") is bilingual.
//
// Order is the club's own progression, entry first. It drives the picker, so
// changing this array changes what the director sees.

export const DTA_BADGES = [
  { key: 'parent_coach',     label: 'Parent Coach',      metal: 'gold',   file: 'parent-coach.svg' },
  { key: 'assistent_trainer',label: 'Assistent Trainer', metal: 'silver', file: 'assistent-trainer.svg' },
  { key: 'jeugd_trainer',    label: 'Jeugd Trainer',     metal: 'bronze', file: 'jeugd-trainer.svg' },
  { key: 'team_coach',       label: 'Team Coach',        metal: 'gold',   file: 'team-coach.svg' },
  { key: 'head_trainer',     label: 'Head Trainer',      metal: 'gold',   file: 'head-trainer.svg' },
  { key: 'trainers_academy', label: 'Trainers Academy',  metal: 'gold',   file: 'trainers-academy.svg' },
  { key: 'administrator',    label: 'Administrator',     metal: 'gold',   file: 'administrator.svg' },
];

/**
 * What a newly confirmed coach gets.
 * Everyone in the Coach Hub is in the Trainers Academy, so this says "you are
 * one of us" rather than "you are on the bottom rung", which is the better
 * thing to be handed on your first day.
 */
export const DEFAULT_BADGE = 'trainers_academy';

const BY_KEY = new Map(DTA_BADGES.map(b => [b.key, b]));

/** The badge for a key, or null. Unknown keys are null, never a broken image. */
export function badgeFor(key) {
  return BY_KEY.get(String(key || '')) || null;
}

/**
 * Where the file lives. Kept here so the path exists in exactly one place;
 * every caller asks for a key and gets a URL.
 */
export function badgeSrc(key) {
  const b = badgeFor(key);
  return b ? `/assets/dta/${b.file}` : null;
}

/** The name to show beside the badge, or '' when there is no badge. */
export function badgeLabel(key) {
  const b = badgeFor(key);
  return b ? b.label : '';
}
